module.exports = __webpack_public_path__ + "img/linkedin.2d8b9991.svg";